{
	"apiKey": "AIzaSyD9b4Z0zb_rxXXkTnDzNJf6iyL15k2AF74",
	"authDomain": "atomic-form.firebaseapp.com",
	"projectId": "atomic-form",
	"storageBucket": "atomic-form.appspot.com",
	"messagingSenderId": "684596391761",
	"appId": "1:684596391761:web:1ca1d448817d7cc43b6d70",
	"measurementId": "G-KM5KV3JED2"
  }